import * as React from "react";
import {cx} from "emotion";

import "./checkbox-line.scss";

import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";

export const CheckboxLine = (
    {
        value, 
        onChange,
        label, 
        className,
        disabled=undefined,
        xdQaName=undefined,
    }
) => (
    <div
        className={cx("checkbox-line checkbox-line-31q", className, {disabled})}
        onClick={() => !disabled && onChange(!value)}
    >
        <div className="label" xd-qa-type="label" xd-qa-name={xdQaName}>
            {label}
        </div>
        {SliderCheckbox({value, onChange, xdQaName,})}
    </div>
);
